import { useReactiveVar } from '@apollo/client';
import {
  NavigationProp,
  useIsFocused,
  useNavigation,
} from '@react-navigation/native';
import ParkingContext from 'context/ParkingContext';
import useIsLoggedIn from 'hooks/useIsLoggedIn';
import { useContext, useEffect } from 'react';
import { featureCountryCode } from 'states/persistInStorage';
import { useAuthStore } from 'stores/authStore';
import { useUiStore } from 'stores/uiStore';
import { changeFutureAppCountryCode } from 'utils/countryUtils';
import { isOnboardingOpen } from 'utils/navigationUtils';

const useParkingZoneChangeCountry = () => {
  const navigation: NavigationProp<any> = useNavigation();
  const { parkingZoneResult: parkingZone } = useContext(ParkingContext);
  const { countryCode: zoneCountry } = parkingZone?.data?.parkZone || {};
  const appCountryCode = useReactiveVar(featureCountryCode);
  const { isLoggedIn } = useIsLoggedIn();
  const focus = useIsFocused();

  useEffect(() => {
    if (
      zoneCountry &&
      appCountryCode !== zoneCountry &&
      isLoggedIn &&
      focus &&
      !isOnboardingOpen(navigation)
    ) {
      useUiStore.getState().setSheetModal('parkingAppLocation');
      useUiStore.getState().setLocationModalShown(true);
      useAuthStore.getState().setCurrentCustomerCountry(zoneCountry);
      changeFutureAppCountryCode(zoneCountry);
    }
  }, [appCountryCode, isLoggedIn, zoneCountry, focus, navigation]);
};

export default useParkingZoneChangeCountry;
